export default __webpack_public_path__ + "static/media/rainbow_rose.81293809.jpg";